export class Pendencia {
  id: number;
  nome: string;
  icone: string;
  ativo: boolean;
  prazoPadrao: number;
}
